import {
  PaymentAndDelivery,
  IdentityConfirmationMode,
  PaymentMode,
  DeliveryMode
} from '../interfaces/paymentAndDelivery.interface';
import { AfterViewInit, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { CommonInfoService } from '../cart-process/common-info.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { DeliveryFormStateService } from '../customer-form/form-state/delivery-form-state.service';
import { YourOfferService } from '../cart-process/your-offer.service';
import { ExternalInterfacesEnum, ExternalInterfacesService } from '../external-interfaces/external-interfaces.service';
import CustomerDetailsService from '../cart-process/customer-details.service';
import { ICartDetails, IPrice } from '../interfaces/cart-details.interface';
import { DataLayerService } from '../customer-actions/data-layer.service';
import { FormStateChange, FormStateChangeService, StateInputFields } from '../customer-form/form-state/form-state-change.service';
import { IdentityConfirmationTypeEnum } from '../models/cartDetails/identityConfirmationType.enum';
import { DeliveryModeEnum } from '../models/cartDetails/deliveryModeEnum.model';

declare const window: any;
declare const P4: any;

@Component({
  selector: 'page-delivery-view-component',
  templateUrl: './page-delivery-view.component.html',
})
export class PageDeliveryViewComponent implements OnInit, AfterViewInit {
  public dataLoaded = false;
  public linkNext: string;
  public offerTitle: string;
  public identityConfirmationModes: IdentityConfirmationMode[];
  public availablePaymentModes: PaymentMode[] = [];
  public requiresIdentityConfirmation: boolean;
  public deliveryCost: IPrice;
  public offlineIdentityConfirmationEnabled: boolean;
  public onlineIdentityConfirmationEnabled: boolean;
  public MIDIdentityConfirmationEnabled: boolean;
  public notRequiredIdentityConfirmationEnabled: boolean;
  public isPosAvailable: boolean;
  public identityConfirmationType: string;

  constructor(
    @Inject('Endpoint') private endpoint: any,
    public yourOffer: YourOfferService,
    public commonInfo: CommonInfoService,
    private elementRef: ElementRef,
    private deliveryFormStateService: DeliveryFormStateService,
    private formStateChangeService: FormStateChangeService,
    private customerDetailsService: CustomerDetailsService,
    private notificationProviderService: NotificationProviderService,
    private externalInterfacesService: ExternalInterfacesService,
    private dataLayerService: DataLayerService
  ) {
    this.getPaymentAndDelivery();
    this.deliveryFormStateService.storeData().set();

    this.externalInterfacesService.getData(ExternalInterfacesEnum.CART_DETAILS);
    this.notificationProviderService.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails) {
        this.customerDetailsService.get();
      }
    });

    this.notificationProviderService.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.offerTitle = commonInfo.offerTitle;
      }
    });

    this.linkNext = this.elementRef.nativeElement.getAttribute('link-next');

    window.reloadCartDetailsInnerNg2 = this.externalInterfacesService.updateCartDetails.bind(this.externalInterfacesService);
  }

  ngOnInit(): void {
    this.dataLayerService.deliveryAndPayment();
    this.dataLayerService.deliveryAndPaymentOfferSets();

    this.formStateChangeService.subscribe(async (stateChange: FormStateChange) => {
      if (stateChange.inputField === StateInputFields.DELIVERY_MODE_NAME) {
        if (stateChange.value) {
          const availableDeliveryModes = this.identityConfirmationModes.find(mode => mode.code === this.identityConfirmationType)?.deliveryModes;

          this.availablePaymentModes = availableDeliveryModes?.length
            ? availableDeliveryModes.find((item: DeliveryMode) => item.code === stateChange.value).paymentModes
            : [];
        }
      }

      if (stateChange.inputField === StateInputFields.IDENTITY_CONFIRMATION_TYPE) {
        if (stateChange.value) {
          this.identityConfirmationType = stateChange.value;
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.deliveryFormStateService.storeData().emit();

    P4.modules.stickyElements.init();
  }

  private getIdentityConfirmationEnabled(identityConfirmationModes: IdentityConfirmationMode[]): void {
    this.offlineIdentityConfirmationEnabled = !!identityConfirmationModes
      .find(mode => mode.code === IdentityConfirmationTypeEnum.OFFLINE)?.deliveryModes.length;
    this.onlineIdentityConfirmationEnabled = !!identityConfirmationModes
      .find(mode => mode.code === IdentityConfirmationTypeEnum.ONLINE)?.deliveryModes.length;
    this.MIDIdentityConfirmationEnabled = !!identityConfirmationModes
      .find(mode => mode.code === IdentityConfirmationTypeEnum.M_OBYWATEL)?.deliveryModes.length;
    this.notRequiredIdentityConfirmationEnabled = !!identityConfirmationModes
      .find(mode => mode.code === IdentityConfirmationTypeEnum.NOT_REQUIRED)?.deliveryModes.length;

    if (this.notRequiredIdentityConfirmationEnabled) {
      this.identityConfirmationType = IdentityConfirmationTypeEnum.NOT_REQUIRED;
    }
  }

  private processPaymentAndDeliveryResponse(response: PaymentAndDelivery): void {
    this.identityConfirmationModes = response.identityConfirmationModes;
    this.isPosAvailable = this.identityConfirmationModes.some((identityMode: IdentityConfirmationMode) =>
      identityMode.deliveryModes.some((deliveryMode: DeliveryMode) => deliveryMode.code === DeliveryModeEnum.POS)
    );
    this.deliveryCost = response.deliveryCost;
    this.requiresIdentityConfirmation = (this.identityConfirmationModes.length &&
                                        !this.identityConfirmationModes.find(mode => mode.code === IdentityConfirmationTypeEnum.NOT_REQUIRED));

    this.getIdentityConfirmationEnabled(this.identityConfirmationModes);

    this.formStateChangeService.setField({
      inputField: this.formStateChangeService.StateInputFields.DELIVERY_COST,
      value: this.deliveryCost
    });
  }

  private getPaymentAndDelivery(): void {
    this.endpoint('checkout.paymentAndDelivery')
      .run()
      .then((response) => this.processPaymentAndDeliveryResponse(response))
      .finally(() => (this.dataLoaded = true));
  }
}
